import { Component, OnInit, ViewChild } from "@angular/core";
import { Title } from "@angular/platform-browser";

import { MainConfig } from "@atenea-cms";
import { EsportsSlideService } from "../shared";

@Component({
  selector: "esports-slide-list",
  templateUrl: "./esports-slide-list.component.html",
  styleUrls: ["./esports-slide-list.component.scss"],
  host: { class: "atn-list-crud" },
})
export class EsportsSlideListComponent implements OnInit {
  constructor(
    private titleService: Title,
    private mainConfig: MainConfig,
    public dataService: EsportsSlideService
  ) {}

  ngOnInit() {
    this.titleService.setTitle(
      "Diapositivas ESports - " + this.mainConfig.cmsName
    );
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/esports-slides/esports-slide-list/esports-slide-list.component.ts